import { createApp } from 'vue'
import app from './app.vue';
import commonStore from '../global/common-store';

export default () => {
  createApp({ components: { RecentlyViewedProducts: app } }).use(commonStore).mount('#vue-rvp')
}